import cn from 'clsx'

import './Text.scss'
import Box, {BoxProps} from 'common/components/utils/Box'

export interface TextProps extends BoxProps {
  as?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  spacing?: boolean
  noWrap?: boolean
  cross?: boolean
  uppercase?: boolean
  lowercase?: boolean
  uppercaseFirstLetter?: boolean
  maxInterval?: boolean
}

export default function Text({
  children,
  as = 'p',
  className,
  spacing,
  noWrap,
  cross,
  uppercase,
  lowercase,
  uppercaseFirstLetter,
  maxInterval,
  ...props
}: TextProps) {
  return (
    <Box
      as={as}
      className={cn(
        className,
        'Text',
        spacing && 'Text_spacing',
        noWrap && 'Text_noWrap',
        cross && 'Text_cross',
        uppercase && 'Text_uppercase',
        lowercase && 'Text_lowercase',
        uppercaseFirstLetter && 'Text_uppercaseFirstLetter',
        maxInterval && 'Text_maxInterval'
      )}
      {...props}
    >
      {children}
    </Box>
  )
}
